import React, { useEffect, useState } from 'react';
import { adminApi, fmtDate } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';

export default function AdminAuditLogPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { adminApi.get('/admin/audit-log').then(r => setItems(r.data.items || [])); }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-serif text-3xl text-[hsl(var(--brand-navy-2))]">Audit log</h1>
      <Card className="bg-white overflow-hidden" data-testid="audit-log-table">
        <table className="w-full text-sm">
          <thead className="bg-[hsl(var(--secondary))]"><tr><th className="p-3 text-left">Date</th><th className="p-3 text-left">Admin</th><th className="p-3 text-left">Action</th><th className="p-3 text-left">Entity</th><th className="p-3 text-left">Details</th></tr></thead>
          <tbody>
            {items.map(i => (
              <tr key={i.id} className="border-t">
                <td className="p-3 text-xs">{fmtDate(i.created_at)}</td>
                <td className="p-3">{i.admin?.email}<div className="text-xs text-[hsl(var(--muted-foreground))]">{i.admin?.role}</div></td>
                <td className="p-3 font-medium">{i.action}</td>
                <td className="p-3">{i.entity_type} / <code className="text-xs">{i.entity_id?.slice(0, 8)}</code></td>
                <td className="p-3 text-xs"><pre className="whitespace-pre-wrap break-all font-mono">{JSON.stringify(i.details || {}, null, 0)}</pre></td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <div className="p-8 text-center text-sm text-[hsl(var(--muted-foreground))]">No log entries</div>}
      </Card>
    </div>
  );
}
